module.exports = __webpack_public_path__ + "static/media/project.f9a37d60.svg";